/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusPrintoutOptionsDto } from './NovitusPrintoutOptionsDto';
import {
    NovitusPrintoutOptionsDtoFromJSON,
    NovitusPrintoutOptionsDtoFromJSONTyped,
    NovitusPrintoutOptionsDtoToJSON,
} from './NovitusPrintoutOptionsDto';
import type { NovitusEDocumentDto } from './NovitusEDocumentDto';
import {
    NovitusEDocumentDtoFromJSON,
    NovitusEDocumentDtoFromJSONTyped,
    NovitusEDocumentDtoToJSON,
} from './NovitusEDocumentDto';
import type { NovitusDeviceControlDto } from './NovitusDeviceControlDto';
import {
    NovitusDeviceControlDtoFromJSON,
    NovitusDeviceControlDtoFromJSONTyped,
    NovitusDeviceControlDtoToJSON,
} from './NovitusDeviceControlDto';
import type { NovitusSystemInfoDto } from './NovitusSystemInfoDto';
import {
    NovitusSystemInfoDtoFromJSON,
    NovitusSystemInfoDtoFromJSONTyped,
    NovitusSystemInfoDtoToJSON,
} from './NovitusSystemInfoDto';
import type { NovitusPrintoutLineDto } from './NovitusPrintoutLineDto';
import {
    NovitusPrintoutLineDtoFromJSON,
    NovitusPrintoutLineDtoFromJSONTyped,
    NovitusPrintoutLineDtoToJSON,
} from './NovitusPrintoutLineDto';

/**
 * 
 * @export
 * @interface NovitusPrintoutDto
 */
export interface NovitusPrintoutDto {
    /**
     * Opcje wydruku
     * @type {NovitusPrintoutOptionsDto}
     * @memberof NovitusPrintoutDto
     */
    options?: NovitusPrintoutOptionsDto;
    /**
     * Tablica linii wydruku (wymagane, co najmniej 1 linia, max 1000)
     * @type {Array<NovitusPrintoutLineDto>}
     * @memberof NovitusPrintoutDto
     */
    lines: Array<NovitusPrintoutLineDto>;
    /**
     * Konfiguracja eDokumentu
     * @type {NovitusEDocumentDto}
     * @memberof NovitusPrintoutDto
     */
    e_document?: NovitusEDocumentDto;
    /**
     * Informacje systemowe
     * @type {NovitusSystemInfoDto}
     * @memberof NovitusPrintoutDto
     */
    system_info?: NovitusSystemInfoDto;
    /**
     * Sterowanie urządzeniem
     * @type {NovitusDeviceControlDto}
     * @memberof NovitusPrintoutDto
     */
    device_control?: NovitusDeviceControlDto;
}

/**
 * Check if a given object implements the NovitusPrintoutDto interface.
 */
export function instanceOfNovitusPrintoutDto(value: object): value is NovitusPrintoutDto {
    if (!('lines' in value) || value['lines'] === undefined) return false;
    return true;
}

export function NovitusPrintoutDtoFromJSON(json: any): NovitusPrintoutDto {
    return NovitusPrintoutDtoFromJSONTyped(json, false);
}

export function NovitusPrintoutDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPrintoutDto {
    if (json == null) {
        return json;
    }
    return {
        
        'options': json['options'] == null ? undefined : NovitusPrintoutOptionsDtoFromJSON(json['options']),
        'lines': ((json['lines'] as Array<any>).map(NovitusPrintoutLineDtoFromJSON)),
        'e_document': json['e_document'] == null ? undefined : NovitusEDocumentDtoFromJSON(json['e_document']),
        'system_info': json['system_info'] == null ? undefined : NovitusSystemInfoDtoFromJSON(json['system_info']),
        'device_control': json['device_control'] == null ? undefined : NovitusDeviceControlDtoFromJSON(json['device_control']),
    };
}

export function NovitusPrintoutDtoToJSON(value?: NovitusPrintoutDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'options': NovitusPrintoutOptionsDtoToJSON(value['options']),
        'lines': ((value['lines'] as Array<any>).map(NovitusPrintoutLineDtoToJSON)),
        'e_document': NovitusEDocumentDtoToJSON(value['e_document']),
        'system_info': NovitusSystemInfoDtoToJSON(value['system_info']),
        'device_control': NovitusDeviceControlDtoToJSON(value['device_control']),
    };
}

